import { useEffect, useState } from "react";
import { LineChart, Line, ResponsiveContainer, Area, AreaChart } from "recharts";
import { Users, TrendingUp, CheckCircle2, Filter } from "lucide-react";

const chartData = Array.from({length: 24}, (_, i) => ({ x: i, v: 30 + Math.round(Math.sin(i/2)*10 + Math.cos(i/3)*8 + i*1.4) }));

const leads = [
  { name: "Anna Reyes", stage: "Qualified", amount: "₱48,000", tone: "cyan" },
  { name: "Marco Dela Cruz", stage: "Blueprint", amount: "₱62,000", tone: "blue" },
  { name: "Kris Villanueva", stage: "Proposal", amount: "₱95,000", tone: "teal" },
  { name: "Joseph Tan", stage: "Building", amount: "₱120,000", tone: "emerald" },
];

export default function MoolahCrmMockup() {
  const [tab, setTab] = useState("pipeline");
  const [count, setCount] = useState(184);
  useEffect(() => {
    const t = setInterval(() => setCount(c => c + (Math.random() > 0.5 ? 1 : 0)), 3200);
    return () => clearInterval(t);
  }, []);

  return (
    <div data-testid="hero-crm-preview" className="relative glass p-4 sm:p-5 w-full max-w-[480px] mx-auto">
      <div className="absolute -inset-1 rounded-[22px] bg-gradient-to-br from-cyan-500/20 to-blue-600/20 blur-2xl -z-10"/>
      <div className="flex items-center justify-between pb-3 border-b border-white/5">
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 rounded-md bg-gradient-to-br from-cyan-400 to-blue-500"/>
          <span className="text-white text-sm font-semibold">Moolah CRM</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="pulse-dot"/>
          <span className="text-[10px] font-mono uppercase tracking-widest text-emerald-400">Live</span>
        </div>
      </div>

      <div className="flex gap-1 mt-3 mb-4 text-[11px] font-mono tracking-wide uppercase">
        {["pipeline","leads","tasks","analytics"].map(t => (
          <button key={t} onClick={() => setTab(t)}
            className={`px-3 py-1.5 rounded-md transition ${tab===t?"bg-cyan-400/15 text-cyan-300 border border-cyan-400/30":"text-slate-500 hover:text-slate-300"}`}>
            {t}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-3 gap-2 mb-4">
        <StatMini icon={<Users className="w-3.5 h-3.5"/>} label="Leads" value={count}/>
        <StatMini icon={<TrendingUp className="w-3.5 h-3.5"/>} label="Velocity" value="+38%"/>
        <StatMini icon={<CheckCircle2 className="w-3.5 h-3.5"/>} label="Closed" value="24"/>
      </div>

      <div className="h-24 -mx-2">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={chartData}>
            <defs>
              <linearGradient id="grad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#38BDF8" stopOpacity={0.6}/>
                <stop offset="100%" stopColor="#38BDF8" stopOpacity={0}/>
              </linearGradient>
            </defs>
            <Area type="monotone" dataKey="v" stroke="#38BDF8" strokeWidth={2} fill="url(#grad)"/>
          </AreaChart>
        </ResponsiveContainer>
      </div>

      <div className="mt-4 space-y-2">
        {leads.slice(0, 3).map(l => (
          <div key={l.name} className="flex items-center justify-between bg-white/[0.02] border border-white/5 rounded-lg px-3 py-2">
            <div>
              <div className="text-sm text-white">{l.name}</div>
              <div className="text-[11px] text-slate-500">{l.stage}</div>
            </div>
            <div className="text-xs font-mono text-cyan-300">{l.amount}</div>
          </div>
        ))}
      </div>

      <div className="mt-4 flex items-center justify-between text-[11px] font-mono uppercase tracking-widest">
        <div className="flex items-center gap-2 text-emerald-400"><span className="pulse-dot"/> BUILDING IN PROGRESS</div>
        <div className="text-slate-500 flex items-center gap-1"><Filter className="w-3 h-3"/> auto-sync</div>
      </div>
    </div>
  );
}

function StatMini({icon,label,value}) {
  return (
    <div className="bg-white/[0.03] border border-white/5 rounded-lg px-3 py-2">
      <div className="flex items-center gap-1.5 text-slate-500 text-[10px] uppercase tracking-wider">{icon}{label}</div>
      <div className="text-white text-base font-semibold mt-0.5">{value}</div>
    </div>
  );
}
